import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { slugMaterialName } from "@utils/helpers"
import priceDownArrow from "@images/priceDownArrow.svg"
import priceUpArrow from "@images/priceUpArrow.svg"

export default ({ material, date, price, img, percentage, unit }) => {
  const { t } = useTranslation()

  return (
    <div
      className={`
        bg-dblue
        h-[106px]
        w-[572px]
        p-[4px]
        flex
        items-center
      `}
    >
      <img
        className={`    
          w-[98px]
          h-[98px]
          `}
        src={img}
        alt={t(slugMaterialName(material) + "_material_name")}
      />
      <div className={`flex flex-col justify-center flex-grow mr-[8px]`}>
        <div className={`flex items-center justify-between`}>
          <div className={`flex flex-col gap-[4px] pl-3`}>
            <span
              className={`
                text-white
                font-inter
                text-[24px]
                font-medium
                leading-normal
                min-w-[175px]
              `}
            >
              {t(slugMaterialName(material) + "_material_name")}
            </span>
            <span
              className={`
                text-white/80 
                font-inter 
                text-[12px] 
                font-normal 
                leading-[120%]
              `}
            >
              {t("Updated")}: {date}
            </span>
          </div>
          <div className={`flex flex-col gap-[4px] items-end`}>
            <div className={`flex items-baseline `}>
              <span
                className={`
                  text-white
                  font-inter
                  text-[20px]
                  font-medium
                  leading-normal
                `}
              >
                {price}
              </span>
              <span
                className={`
                  text-white
                  font-inter
                  text-[16px]
                  font-normal
                  leading-normal
                  whitespace-nowrap
                `}
              >
                /{unit}
              </span>
            </div>
            <div className={`flex gap-[2px] items-center`}>
              <span
                className={`
                  text-white
                  font-inter
                  text-[14px]
                  font-normal
                  leading-[120%]
                `}
              >
                {percentage}%
              </span>
              <img
                className={``}
                src={percentage < 0 ? priceDownArrow : priceUpArrow}
                alt={percentage < 0 ? t("price down") : t("price up")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
